(function() {
    'use strict';

    angular
        .module('Controllers')
        .directive('sodTopbarMenu', sodTopbarMenuDirective);

    function sodTopbarMenuDirective($document, uriActiveLinkService) {
        return {
            restrict: 'A',
            link: sodTopbarMenuDirectiveLink
        };

        function sodTopbarMenuDirectiveLink(scope, elem) {
            $document.on('click', function() {
                //e.preventDefault();
                if (isShown()) {
                    elem.removeClass('is-active');
                    elem.find('.menu.submenu.is-dropdown-submenu').removeClass('js-dropdown-active');
                }
            });

            elem.on('click', function(e) {
                e.stopPropagation();
                if (isShown()) {
                    elem.removeClass('is-active');
                    elem.find('.menu.submenu.is-dropdown-submenu').removeClass('js-dropdown-active');
                } else {
                    var otherIsActiveDoms = $document.find('li.has-submenu.is-active');
                    otherIsActiveDoms.removeClass('is-active');
                    otherIsActiveDoms.find('.menu.submenu.is-dropdown-submenu').removeClass('js-dropdown-active');
                    elem.addClass('is-active');
                    elem.find('.menu.submenu.is-dropdown-submenu').addClass('js-dropdown-active');
                }
            });

            elem.on('click', '> ul > li > a', function(e) {
                e.stopPropagation();
                elem.removeClass('is-active');
                elem.find('.menu.submenu.is-dropdown-submenu').removeClass('js-dropdown-active');
            });

            function isShown() {
                return elem.hasClass('is-active');
            }

            scope.isActive = function(path) {
                return uriActiveLinkService(path);
            };
        }
    }
})();